<template>
  <div class="l-header_notification" v-click-outside="notificationClose">
    <button class="l-header_bell" @click="notificationOpen">
      <img
        src="@/assets/images/notifications-outline.svg"
        class="notification_image"
        alt=""
        srcset=""
      />
      <div :class="totalUnread >= 100 ? 'notification_high_count' : ''" class="notification_count" v-if="totalUnread">{{totalCountNotification}}</div>
    </button>
    <div class="notification_content" :class="{ isActive: isOpenNoti }">
      <div class="notification_header">オークション通知</div>
      <div class="notification_wrapper">
        <div
          :class="tabName === NOTI_TABS.TAB_ALL ? 'active' : ''"
          @click="changeTab(NOTI_TABS.TAB_ALL)"
        >すべて</div>
        <div
          class="unread-tab"
          :class="tabName === NOTI_TABS.TAB_UNREAD ? 'active ' : ''"
          @click="changeTab(NOTI_TABS.TAB_UNREAD)"
        >未読</div>
      </div>
      <div
        class="notification_detail-wrapper"
        @scroll="handleLoadMore"
        :class="(isLoadingAll || isLoadingUnread) && 'pt-3'"
      >
        <template v-if="tabName === NOTI_TABS.TAB_ALL">
          <div v-for="item in allNotifications" :key="item.id" :class="item.is_delete && 'wrapper-remove-content' || ''">
            <div class="content_detail-wrapper">
                <div class="content_detail" :class="item.is_delete && 'remove-content-detail'">
                  <div class="img" v-if="!item.is_delete">
                    <img src="@/assets/images/building-solid.svg" />
                  </div>

                  <div :class="!item.is_delete ? 'overflow-hidden' : 'd-flex'" class="w-100 pl-1">
                    <div
                      class="r-notification"
                      :class="item.is_delete && 'justify-content-center'"
                      @click="!item.is_delete ? directPage(item) : null"
                    >
                      <div class="l-detail">
                        <div class="l-detail-header d-flex" v-if="!item.is_delete">
                          <div class="w-75">
                          {{item.title}}
                          </div>
                          <div class="r-detail d-flex text-xs font-weight-normal" v-if="!item.is_delete">
                             {{formatDate(item.received_date)}}
                          </div>
                        </div>
                        <div class="d-flex l-content">
                          {{!item.is_delete ? item.content : '通知を削除しました。'}}
                        </div>
                      </div>
                      <!-- <div class="r-detail d-flex text-xs" v-if="!item.is_delete">
                        {{formatDate(item.received_date)}}
                        <div class="notification-unread ml-2" v-if="!item.read_flag"></div>
                        <div class="ml-3" v-if="item.read_flag"></div>
                      </div> -->
                       <div class="notification-unread ml-2" v-if="!item.read_flag"></div>
                        <div class="ml-3" v-if="item.read_flag"></div>
                    </div>
                    <div class="trash" v-if="!item.is_delete" @click="removeNotification(item, NOTI_TABS.TAB_ALL)"></div>
                    <img
                      class="undo-notification"
                      src="@/assets/images/undo.svg"
                      v-if="item.is_delete"
                      @click="undoNotification(item, NOTI_TABS.TAB_ALL)"
                    />
                  </div>
                </div>
            </div>
          </div>
          <template v-if="isLoadingAll">
            <AppLoading />
          </template>
          <div class="text-center pt-3" v-if="!allNotifications.length && !isLoadingAll">新しい通知はありません</div>
        </template>
        <template v-if="tabName === NOTI_TABS.TAB_UNREAD">
          <div v-for="item in unreadNotifications" :key="item.id" :class="item.is_delete && 'wrapper-remove-content' || ''">
            <div class="content_detail-wrapper">
                <div class="content_detail" :class="item.is_delete && 'remove-content-detail'">
                  <div class="img" v-if="!item.is_delete">
                    <img src="@/assets/images/building-solid.svg" />
                  </div>

                  <div :class="!item.is_delete ? 'overflow-hidden' : 'd-flex'" class="w-100 pl-1">
                    <div
                      class="r-notification"
                      :class="item.is_delete && 'justify-content-center'"
                      @click="!item.is_delete ? directPage(item) : null"
                    >
                      <div class="l-detail __notification" :class="item.is_delete && 'w-100'">
                        <div class="l-detail-header" v-if="!item.is_delete">{{item.title}}</div>
                        <div class="l-content">
                          {{!item.is_delete ? item.content : '通知を削除しました。'}}</div>
                      </div>
                      <div class="r-detail d-flex text-xs" v-if="!item.is_delete">
                        {{formatTimeHour(
                          $dayjs(item.received_date).format(DEFAULT_DATE_TIME_FORMAT))}}
                        <div class="notification-unread ml-2"></div>
                      </div>
                    </div>
                    <div class="trash" v-if="!item.is_delete" @click="removeNotification(item, NOTI_TABS.TAB_UNREAD)"></div>
                    <img
                      class="undo-notification"
                      src="@/assets/images/undo.svg"
                      v-if="item.is_delete"
                      @click="undoNotification(item, NOTI_TABS.TAB_UNREAD)"
                    />
                  </div>
                </div>
            </div>
          </div>
          <template v-if="isLoadingUnread">
            <AppLoading />
          </template>
          <div class="text-center pt-3" v-if="!unreadNotifications.length && !isLoadingUnread">新しい通知はありません</div>
        </template>
      </div>
      <div class="notification_button" @click="notificationClose">閉じる</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NOTI_TABS, FORMAT_DATE_NOTIFICATION, DEFAULT_DATE_TIME_FORMAT } from '@/constants/common';
import { formatTimeHour } from '@/utils/format';
import AppLoading from '@/components/Loading/AppLoading.vue';

export default {
  props: {
    unreadTotal: Number,
  },
  components: {
    AppLoading,
  },
  data() {
    return {
      NOTI_TABS,
      FORMAT_DATE_NOTIFICATION,
      DEFAULT_DATE_TIME_FORMAT,
      isOpenNoti: false,
      tabName: '',
      currentPageAll: 1,
      currentPageUnread: 1,
      isNotClose: false,
      isLoadingAll: false,
      isLoadingUnread: false,
    };
  },

  computed: {
    ...mapGetters('notification', [
      'allNotifications',
      'unreadNotifications',
      'lastPageAllNotifications',
      'lastPageUnreadNotifications',
      'totalUnread'
    ]),

    totalCountNotification() {
      return this.totalUnread >= 100 ? '99+' : this.totalUnread;
    }
  },

  created() {
    const w = window.innerWidth;
    if (w < 500) {
      this.mobileDisplay = true;
    }
    this.tabName = NOTI_TABS.TAB_ALL;
  },

  methods: {
    formatTimeHour,
    async getAllNotification() {
      await this.$store.dispatch('notification/getNotificationAll', this.currentPageAll);
      this.isLoadingAll = false;
      if (this.currentPageAll > 1 && this.allNotifications.length) {
        this.handleScrollNotifications();
      }
    },
    async getUnreadNotification() {
      await this.$store.dispatch('notification/getNotificationUnread', this.currentPageUnread);
      this.isLoadingUnread = false;
      if (this.currentPageUnread > 1 && this.unreadNotifications.length) {
        this.handleScrollNotifications();
      }
    },
    handleScrollNotifications() {
      const scroll = document.querySelector('.notification_detail-wrapper');
      scroll.scrollTo(0, scroll.scrollHeight / 2.5);
    },
    handleLoadMore() {
      const scroll = document.querySelector('.notification_detail-wrapper');
      const isLoad = this.tabName === NOTI_TABS.TAB_ALL ? this.isLoadingAll : this.isLoadingUnread;
      const heightLoadData = Math.round(scroll.offsetHeight * 0.3);
      if (scroll.scrollHeight - scroll.scrollTop - heightLoadData < scroll.offsetHeight && scroll.scrollTop && !isLoad) {
        if (this.tabName === NOTI_TABS.TAB_ALL && !this.isLoadingAll) {
          this.currentPageAll += 1;
          if (this.currentPageAll <= this.lastPageAllNotifications) {
            this.isLoadingAll = true;
            this.getAllNotification();
          }
        } else if (this.tabName === NOTI_TABS.TAB_UNREAD && !this.isLoadingUnread) {
          this.currentPageUnread += 1;
          if (this.currentPageUnread <= this.lastPageUnreadNotifications) {
            this.isLoadingUnread = true;
            this.getUnreadNotification();
          }
        }
        return;
      }
      return;
    },
    formatDate(date) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        return this.$dayjs(`${date.replace(' ', 'T')}Z`).format(FORMAT_DATE_NOTIFICATION);
      }
      return this.$dayjs(`${date}Z`).format(FORMAT_DATE_NOTIFICATION);
    },
    removeNotification(item, type) {
      const removeData = { item, type };
      this.isNotClose = true;
      if (type === NOTI_TABS.TAB_ALL) {
        this.allNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = true;
          }
        });
      } else {
        this.unreadNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = true;
          }
        });
      }
      this.$store.dispatch('notification/deleteNotification', item.id);
      setTimeout(() => {
        if (item.is_delete) this.$store.dispatch('notification/clearDeleteNotification', removeData);
        this.isNotClose = false;
      }, 5000);
    },
    undoNotification(item, type) {
      this.isNotClose = true;
      if (type === NOTI_TABS.TAB_ALL) {
        this.allNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = false;
          }
        });
      } else {
        this.unreadNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = false;
          }
        });
      }
      this.$store.dispatch('notification/undoNotification', item.id);
      setTimeout(() => {
        this.isNotClose = false;
      }, 1000);
    },
    directPage(item) {
      if (!item.read_flag) {
        this.$store.dispatch('notification/updateNotification', item.id);
        if (!item.redirect_url) return;
      }
      if (item.redirect_url) this.$router.push(`${item.redirect_url}`);
      this.isNotClose = false;
      this.notificationClose();
    },
    notificationOpen() {
      this.isOpenNoti = !this.isOpenNoti;
      if (this.isOpenNoti) {
        this.isLoadingAll = !this.isLoadingAll;
        this.getAllNotification();
      }
      if (!this.isOpenNoti) this.clearNotifications();
    },
    notificationClose() {
      if (this.isOpenNoti && !this.isNotClose) {
        this.clearNotifications();
      }
    },
    clearNotifications() {
      this.isOpenNoti = false;
      this.tabName = NOTI_TABS.TAB_ALL;
      this.currentPageAll = 1;
      this.currentPageUnread = 1;
      this.$store.dispatch('notification/clearListNotifications');
    },
    changeTab(type) {
      if (this.tabName !== type) {
        this.tabName = type;
        document.querySelector('.notification_detail-wrapper').scrollTo(0, 0);
      }
      if (type === NOTI_TABS.TAB_ALL && !this.allNotifications.length) {
        this.isLoadingAll = !this.isLoadingAll;
        this.getAllNotification();
      }
      if (type === NOTI_TABS.TAB_UNREAD && !this.unreadNotifications.length) {
        this.isLoadingUnread = !this.isLoadingUnread;
        this.getUnreadNotification();
      }
    }
  },
};
</script>
